import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createAgreement } from "../../api/Agreement";
import toast from "react-hot-toast";
import EditForm from "../../components/EditForm";

const CreateAgreementPage = () => {
  const { getAccessToken, user } = useAuth();
  const navigate = useNavigate();
  const [agreement, setAgreement] = useState({
    name: "",
    status: "Active",
    comment: "",
    invoicingPeriod: "",
    autoInvoicing: false,
    createdBy: user?.username || "System",
    updatedBy: user?.username || "System",
  });
  const [hasChanges, setHasChanges] = useState(false);

  const handleBackClick = () => {
    if (hasChanges) {
      if (window.confirm("Discard changes?")) {
        navigate(-1);
      }
    } else {
      navigate(-1);
    }
  };

  const handleCreateAgreement = async () => {
    try {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      console.log("🔄 Final Agreement Object before API Call:", agreement);

      const createResponse = await createAgreement(agreement, accessToken);
      console.log("Create Agreement Response:", createResponse);
      
      toast.success("Agreement created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });

      navigate(-1);
    } catch (error) {
      console.error("Create error:", error.response?.data || error.message);
      toast.error(`Error: ${error.response?.data?.message || "Failed to create agreement"}`);
    }
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create Agreement</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={handleBackClick}>
                  Cancel
                </button>
                <button className="btn btn-primary" disabled={!hasChanges} onClick={handleCreateAgreement}>
                  Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <EditForm
                data={agreement}
                setData={setAgreement}
                setHasChanges={setHasChanges}
                disabled={false}
                fields={[
                  { key: "name", label: "Name", type: "text" },
                  { key: "status", label: "Status", type: "dropdown", options: [
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                    ] },
                  { key: "comment", label: "Comment", type: "text" },
                  { key: "invoicingPeriod", label: "Invoicing period", type: "dropdown", options: [
                    { value: "monthly", label: "Monthly" },
                    { value: "quarterly", label: "Quarterly" },
                  ]},
                  { key: "domainOwnerIdentifiersCsv", label: "Name SRS Id(s)", type: "text" },
                  { key: "createUserFormUrl", label: "Create user URL", type: "text" },
                  { key: "updateUserFormUrl", label: "Update user URL", type: "text" },
                  { key: "deleteUserFormUrl", label: "Delete user URL", type: "text" },
                  { key: "supportManualUrl", label: "Support manual URL", type: "text" },
                  { key: "autoInvoicing", label: "Automated Invoicing", type: "switch" },
                ]}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateAgreementPage;